<template>
  <div class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-center py-8 justify-center min-h-screen">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-black opacity-50"></div>
      </div>
      <div
        class="bg-white rounded-lg overflow-hidden shadow-xl px-6 py-6 z-50 min-w-[90vw] md:min-w-[80vw] lg:min-w-[900px] xl:min-w-[1024px] md:max-w-[80vw] lg:max-w-[900px] xl:max-w-[1024px]"
      >
        <div class="flex justify-between items-center mb-6">
          <h2 class="text-xl font-medium text-gray-800 dark:text-white">
            Registro de acceso a módulos del sistema
          </h2>
          <button
            @click="isActive"
            class="text-gray-500 hover:text-gray-700 w-8 h-8 flex items-center justify-center hover:bg-gray-200 rounded-lg"
          >
            <svg class="w-5 h-5">
              <use href="../../../assets/svg/icon.svg#cancel" />
            </svg>
          </button>
        </div>
        <AccessForms v-if="loadingModules" />
        <form class="w-full space-y-6" @submit.prevent v-else>
          <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Sucursales
              </span>
              <Stores @send-data="getStores" />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Usuarios
              </span>
              <div
                v-if="refreshUser"
                class="py-2 text-sm rounded-lg border-2 px-3 bg-gray-100 text-gray-400"
              >
                Selecciona una sucursal
              </div>
              <Users v-else @send-data="getUsers" :idstore="dataForm.idStore" />
            </label>
            <div
              v-if="dataForm.containAccess"
              class="md:col-span-2 lg:col-span-3 bg-red-100 px-3 py-3 rounded-lg text-red-700 text-sm font-semibold"
            >
              El usuario ya cuenta con acceso, si deseas agregarle un acceso
              más, solo dale click al módulo que deseas permitir acceder
            </div>
            <div
              class="md:col-span-2 lg:col-span-3 bg-orange-100 px-3 py-3 rounded-lg text-orange-600 text-sm"
            >
              Para dar acceso a ciertas partes del modulo del sistema a un
              usuario, por favor primero selecciona una sucursal y luego
              selecciona el usuario al cual se le quiere dar el acceso, debes de
              estar seguro de dar ese privilegio al usuario seleccionado.
            </div>
            <div
              class="md:col-span-2 lg:col-span-3 flex flex-wrap gap-3"
              v-if="dataForm.idUser !== null"
            >
              <button
                type="button"
                class="bg-slate-800 text-white px-4 py-2 font-semibold text-sm rounded-lg hover:shadow-sm hover:shadow-slate-500 active:scale-95 flex items-center disabled:opacity-60 disabled:cursor-not-allowed"
                @click="selectAllModules"
                :disabled="selectAllInProgress"
              >
                <div class="flex items-center" v-if="selectAllInProgress">
                  <svg class="w-4 h-4 mr-3 animate-spin">
                    <use href="../../../assets/svg/icon.svg#spinnerForBlue" />
                  </svg>
                  Procesando selección
                </div>
                <span v-else>Seleccionar todo</span>
              </button>
              <button
                v-if="!dataForm.containAccess && hasPendingSelections"
                type="button"
                class="bg-white border border-slate-300 text-slate-700 px-4 py-2 font-semibold text-sm rounded-lg hover:bg-slate-50 active:scale-95"
                @click="clearPendingSelection"
              >
                Limpiar selección
              </button>
            </div>
            <div
              class="bg-gray-100 shadow-md border border-blue-200 rounded-lg overflow-hidden"
              v-for="(dataModule, i) in dataModules"
              :key="i"
            >
              <div class="px-4 py-3 text-gray-700 font-semibold text-sm flex items-center justify-between gap-3">
                <div class="flex items-center min-w-0">
                  <font-awesome-icon
                    :icon="dataModule.icon"
                    class="w-4 h-4 mr-2 text-gray-400"
                  />
                  <span class="truncate">{{ dataModule.description }}</span>
                </div>
                <button
                  type="button"
                  class="text-xs font-semibold text-blue-700 bg-blue-100 hover:bg-blue-200 px-3 py-1 rounded-lg whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed"
                  @click="selectAllByModule(dataModule)"
                  :disabled="selectAllInProgress"
                >
                  Marcar todo
                </button>
              </div>
              <div class="py-4 px-3 bg-white h-full">
                <label
                  class="flex flex-col mr-5 mb-4 mt-4 cursor-pointer"
                  v-for="(submodule, e) in dataModule.submodules"
                  :key="e"
                  @click="submodule.state ? deleteAccess(submodule.description,submodule.accessId,$event,showAccess) : null"
                >
                  <div
                    class="relative inline-flex items-center h-6 cursor-pointer"
                  >
                    <input
                      type="checkbox"
                      class="sr-only peer"
                      :disabled="submodule.state"
                      :checked="isSubmoduleChecked(submodule)"
                      @change="
                        addDataModules($event, submodule.idmodule, submodule.id)
                      "
                    />
                    <div
                      class="w-11 h-6 bg-gray-300 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-1 after:left-[4px] after:bg-white after:border-transparent after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-green-500"
                    ></div>
                    <span
                      class="ml-3 text-sm font-medium text-gray-500 dark:text-gray-300"
                    >
                      {{ submodule.description }}
                    </span>
                  </div>
                </label>
              </div>
            </div>
          </div>

          <div class="flex mt-[3.5rem!important] lg:mt-[2rem!important]">
            <button
              class="bg-blue-500 text-white px-4 py-2 font-semibold text-sm rounded-lg hover:shadow-sm hover:shadow-blue-600 active:scale-95 flex items-center"
              @click="insert"
              :disabled="spinner === true"
              v-if="!dataForm.containAccess"
            >
              <div class="flex items-center" v-if="spinner">
                <svg class="w-4 h-4 mr-3 animate-spin">
                  <use href="../../../assets/svg/icon.svg#spinnerForBlue" />
                </svg>
                Registrando Información
              </div>
              <span v-else>Registrar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import {
  confirmationOfRecord,
  errorActions,
  uploadData,
  warningActions,
} from "@/alerts";
import { observer } from "@/observer";
import axios from "../../../api";

import Users from "@/components/PublicComponents/Users.vue";
import Stores from "@/components/PublicComponents/Stores.vue";

import AccessForms from "@/components/Loadings/AccessForms.vue";
import { localTypeUser } from "@/publicjs/localStorage";
import deleteAccess from "@/repository/users/deleteAccess";

export default {
  name: "RegisterAccess",
  props: {
    activeModal: {
      type: Function,
      required: true,
    },
    getdata: {
      type: Function,
      required: true,
    },
  },
  components: {
    Users,
    Stores,
    AccessForms,
  },
  setup(props) {
    function isActive() {
      props.activeModal(true);
    }

    const spinner = ref(false); // Sirve para mostrar un loading al momento de enviar información

    const dataForm = ref({
      idStore: null,
      idUser: null,
      containAccess: false,
      existeAccess: false,
    });

    //funcion para obtener los modulos completos del sistema
    const dataModules = ref([]);
    const loadingModules = ref(true);
    const normalizeModules = (modules) =>
      modules.map((module) => ({
        ...module,
        submodules: (module.submodules || []).map((submodule) => ({
          ...submodule,
          state: !!submodule.state,
          accessId: submodule.accessId ?? null,
          pendingState: false,
        })),
      }));

    const getSoftwareModules = async () => {
      loadingModules.value = true;
      const response = await axios
        .get("modulos_del_sistema_all/all")
        .catch((error) => {
          errorActions(error);
        });
      if ((await response.data.length) === 0) {
        warningActions(
          "No pudimos encontrar los modulos y submódulos del sistema"
        );
      }
      const userType = await localTypeUser();
      const DATA = await response.data;

      if (userType === "SUPERADMIN_ROOT") {
        dataModules.value = normalizeModules(DATA);
      } else {
        dataModules.value = normalizeModules(
          DATA.filter(
            (item) =>
              item.description !== "Módulos del sistema" &&
              item.description !== "Modulos"
          )
        );
      }

      loadingModules.value = false;
    };

    //ARRAY PARA AGREGAR EL ACCESO DE MODULOS DE LOS USUARIOS
    const arrayModules = ref([]);
    const hasPendingSelections = ref(false);
    const selectAllInProgress = ref(false);

    const syncPendingSelectionsState = () => {
      hasPendingSelections.value = dataModules.value.some((module) =>
        module.submodules.some((submodule) => submodule.pendingState)
      );
    };

    const resetPendingSelectionState = () => {
      arrayModules.value = [];
      dataModules.value = dataModules.value.map((module) => ({
        ...module,
        submodules: module.submodules.map((submodule) => ({
          ...submodule,
          pendingState: false,
        })),
      }));
      syncPendingSelectionsState();
    };

    const isSubmoduleChecked = (submodule) =>
      !!submodule.state || !!submodule.pendingState;

    const addDataModules = async (e, idModule, idSubmodule) => {
      // si el usuario ya tiene acceso insertar el nuevo acceso
      if (dataForm.value.containAccess) {
        uploadData(
          "Agregando permiso",
          "Espere un momento mientras agregamos el permiso del usuario"
        );
        e.target.checked = false;
        await addAccess(dataForm.value.idUser, idModule, idSubmodule);
        if (dataForm.value.existeAccess === true) {
          dataForm.value.existeAccess = false;
        } else {
          e.target.checked = true;
        }
      } else {
        // de lo contrario agregar a un array de objetos
        if (dataForm.value.idUser === null) {
          errorActions("Selecciona un usuario y vuelve a intentarlo");
          e.target.checked = false;
          return;
        }
        // verifica si existe un objeto con el valor que le estamos enviando
        const foundIndex = arrayModules.value.findIndex(
          (module) => module.idSubmodules === idSubmodule
        );

        const currentModule = dataModules.value.find(
          (module) => module.id === idModule
        );
        const currentSubmodule = currentModule?.submodules.find(
          (submodule) => submodule.id === idSubmodule
        );

        // si existe el registro con el mismo id lo eliminamos
        if (foundIndex > -1) {
          arrayModules.value.splice(foundIndex, 1);
          if (currentSubmodule) {
            currentSubmodule.pendingState = false;
          }
        } else {
          // si no existe simplemente agregamos el objeto al arreglo
          const newObj = {
            id: arrayModules.value.length + 1,
            idUser: dataForm.value.idUser,
            idModules: idModule,
            idSubmodules: idSubmodule,
          };
          arrayModules.value.push(newObj);
          if (currentSubmodule) {
            currentSubmodule.pendingState = true;
          }
        }

        syncPendingSelectionsState();
      }
    };

    const clearPendingSelection = () => {
      resetPendingSelectionState();
    };

    const getUncheckedSubmodules = () =>
      dataModules.value.flatMap((module) =>
        module.submodules
          .filter((submodule) => !submodule.state)
          .map((submodule) => ({
            idModule: submodule.idmodule,
            idSubmodule: submodule.id,
          }))
      );

    const getUncheckedSubmodulesByModule = (module) =>
      module.submodules
        .filter((submodule) => !submodule.state)
        .map((submodule) => ({
          idModule: submodule.idmodule,
          idSubmodule: submodule.id,
        }));

    const submitMissingSubmodules = async (
      uncheckedSubmodules,
      uploadTitle,
      uploadMessage
    ) => {
      if (uncheckedSubmodules.length === 0) {
        warningActions("El usuario ya tiene todos los módulos disponibles");
        return 0;
      }

      if (!dataForm.value.containAccess) {
        arrayModules.value = uncheckedSubmodules.map((submodule, index) => ({
          id: index + 1,
          idUser: dataForm.value.idUser,
          idModules: submodule.idModule,
          idSubmodules: submodule.idSubmodule,
        }));

        dataModules.value = dataModules.value.map((currentModule) => ({
          ...currentModule,
          submodules: currentModule.submodules.map((submodule) => ({
            ...submodule,
            pendingState: uncheckedSubmodules.some(
              (item) => item.idSubmodule === submodule.id
            )
              ? true
              : submodule.pendingState,
          })),
        }));

        syncPendingSelectionsState();
        return uncheckedSubmodules.length;
      }

      selectAllInProgress.value = true;
      uploadData(uploadTitle, uploadMessage);

      arrayModules.value = uncheckedSubmodules.map((submodule, index) => ({
        id: index + 1,
        idUser: dataForm.value.idUser,
        idModules: submodule.idModule,
        idSubmodules: submodule.idSubmodule,
      }));

      const response = await axios
        .post(
          "accesos",
          {
            modules: arrayModules.value,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .catch(function (error) {
          errorActions(error);
          return null;
        });

      if (!response?.data) {
        selectAllInProgress.value = false;
        return 0;
      }

      const insertedPermissions = Number(response.data.inserted || 0);

      await showAccess();
      props.getdata();
      selectAllInProgress.value = false;
      arrayModules.value = [];

      if (insertedPermissions > 0) {
        confirmationOfRecord("Los accesos del usuario ");

        observer.observe(
          document.querySelector(".swal2-container"),
          { box: "content-box" },
          10
        );
      }

      return insertedPermissions;
    };

    const selectAllModules = async () => {
      if (dataForm.value.idUser === null) {
        errorActions("Selecciona un usuario y vuelve a intentarlo");
        return;
      }

      const uncheckedSubmodules = getUncheckedSubmodules();

      await submitMissingSubmodules(
        uncheckedSubmodules,
        "Agregando permisos",
        "Espere un momento mientras agregamos todos los permisos disponibles"
      );
    };

    const selectAllByModule = async (module) => {
      if (dataForm.value.idUser === null) {
        errorActions("Selecciona un usuario y vuelve a intentarlo");
        return;
      }

      const uncheckedSubmodules = getUncheckedSubmodulesByModule(module);

      await submitMissingSubmodules(
        uncheckedSubmodules,
        `Agregando permisos del módulo ${module.description}`,
        `Espere un momento mientras agregamos los permisos disponibles del módulo ${module.description}`
      );
    };

    onMounted(async () => {
      await getSoftwareModules();
    });

    //recepcion de datos desde el componente publico, todas los usuarios
    const getUsers = async (data) => {
      dataForm.value.idUser = data;
      resetPendingSelectionState();
      await existAccessUser();
      await showAccess();
    };
    //recepcion de datos desde el componente publico, todos los sucursales
    const refreshUser = ref(true); // variable para refresecar el componente de usuarios
    const getStores = async (data) => {
      refreshUser.value = true;
      dataForm.value.idStore = data;
      dataForm.value.idUser = null;
      dataForm.value.containAccess = false;
      resetPendingSelectionState();
      await getUsers();
      refreshUser.value = false;
    };

    const currentAccess = ref([]);
    const showAccess = async () => {
      const response = await axios
        .get("accesos-de-usuario/" + dataForm.value.idUser)
        .catch((error) => {
          currentAccess.value = [];
          errorActions(error);
        });

      currentAccess.value = response.data;
      // Actualizamos los módulos con el estado de acceso
      dataModules.value = dataModules.value.map((module) => {
        const updatedSubmodules = module.submodules.map((submodule) => {
          const access = currentAccess.value.find(
            (access) =>
              access.idmodulos_del_sistema === module.id &&
              access.idsubmodulos === submodule.id
          );

          return {
            ...submodule,
            state: !!access,
            accessId: access ? access.id : null,
            pendingState: false,
          };
        });

        return {
          ...module,
          submodules: updatedSubmodules,
          state: updatedSubmodules.some((submodule) => submodule.state),
        };
      });

      syncPendingSelectionsState();

    };
    // funcion para validar si el usuario ya tiene un acceso registrado con anterioridad
    const existAccessUser = async () => {
      const response = await axios
        .get("accesos/" + dataForm.value.idUser, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .catch((error) => {
          errorActions(error);
        });
      if (!response?.data) {
        dataForm.value.containAccess = false;
        return;
      }
      const data = await response.data;
      if (data.msg === false) {
        dataForm.value.containAccess = false;
      } else if (data.msg === true) {
        dataForm.value.containAccess = true;
      }
    };

    // funcion para agregar mas accesos al usuario despues de haber registrado su acceso por primera vez
    const addAccess = async (
      idUser,
      idModule,
      idSubmodule,
      options = { silent: false, refreshAfterInsert: true }
    ) => {
      const { silent, refreshAfterInsert } = options;

      const response = await axios
        .post(
          "accesos",
          {
            idUser,
            idModules: idModule,
            idSubmodules: idSubmodule,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .catch(function (error) {
          errorActions(error);
          return null;
        });
      if (!response?.data) {
        return false;
      }
      const data = await response.data;

      if (Number(data.inserted || 0) === 0 && Number(data.updated || 0) === 0) {
        dataForm.value.existeAccess = true;
        if (refreshAfterInsert) {
          await showAccess();
        }
        return false;
      }

      if (data.msg === true) {
        if (!silent) {
          confirmationOfRecord("El acceso del usuario ");

          observer.observe(
            document.querySelector(".swal2-container"),
            { box: "content-box" },
            10
          );
        }
        props.getdata();
        arrayModules.value = [];
        if (refreshAfterInsert) {
          await showAccess();
        }
        return true;
      } else if (data.msg === "Request failed with status code 500") {
        if (!silent) {
          errorActions("Request failed with status code 500");
        }
      } else {
        if (!silent) {
          errorActions(
            "Lo sentimos, no pudimos registrar el acceso para el usuario"
          );
        }
      }

      return false;
    };

    //counter para saber si ya finalizo de registrar los modulos y submodulo del usuario

    const insert = async () => {
      if (dataForm.value.idStore === null) {
        errorActions("Selecciona un sucursal");
        return;
      }
      if (dataForm.value.idUser === null) {
        errorActions("Selecciona un usuario");
        return;
      }
      if (
        arrayModules.value.length === 0 ||
        arrayModules.value.length === null
      ) {
        errorActions("No has seleccionado los modulos para el usuario");
        return;
      }
      spinner.value = true;
      const response = await axios
        .post(
          "accesos",
          {
            modules: arrayModules.value,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .catch(function (error) {
          errorActions(error);
          spinner.value = false; //dejando activo al boton
          return null;
        });
      if (!response?.data) {
        return;
      }
      const data = await response.data;
      if (data.msg === true) {
        confirmationOfRecord("El acceso del usuario ");

        //codigo para evitar el error de [resize observer]
        observer.observe(
          document.querySelector(".swal2-container"),
          { box: "content-box" },
          10
        );
        props.getdata();
        spinner.value = false; //dejando activo al boton
        arrayModules.value = [];
        await props.activeModal();
      } else if (data.msg === "Request failed with status code 500") {
        errorActions("Request failed with status code 500");
        spinner.value = false; //dejando activo al boton
      } else if (data.msg === "idExist") {
        errorActions(
          "El usuario ya tiene un acceso asignado por favor, busca al usuario y modifica sus acceso si es necesario"
        );
        spinner.value = false; //dejando activo al boton
      } else {
        errorActions(
          "Lo sentimos, no pudimos registrar el acceso para el usuario"
        );
        spinner.value = false; //dejando activo al boton
      }
    };
    return {
      isActive,
      dataForm,
      insert,
      spinner,
      getStores,
      getUsers,
      refreshUser,
      dataModules,
      loadingModules,
      addDataModules,
      clearPendingSelection,
      deleteAccess,
      hasPendingSelections,
      isSubmoduleChecked,
      selectAllInProgress,
      selectAllByModule,
      selectAllModules,
      showAccess
    };
  },
};
</script>
